import type { ThemeOptions } from '@mui/material/styles';
import type { TypographyPropsVariantOverrides } from '@mui/material/Typography';

declare module '@mui/material/styles' {
  interface TypographyVariants {
    code: React.CSSProperties;
  }
  interface TypographyVariantsOptions {
    code?: React.CSSProperties;
  }
}

declare module '@mui/material/Typography' {
  interface TypographyPropsVariantOverrides {
    code: true;
  }
}

export const typography: ThemeOptions['typography'] = {
  fontFamily: '"Inter", -apple-system, BlinkMacSystemFont, "Segoe UI", system-ui, sans-serif',
  h1: { fontFamily: '"Inter Tight", "Inter", sans-serif', fontSize: '2.5rem', fontWeight: 700, lineHeight: 1.1 },
  h2: { fontFamily: '"Inter Tight", "Inter", sans-serif', fontSize: '2rem', fontWeight: 700, lineHeight: 1.2 },
  h3: { fontFamily: '"Inter Tight", "Inter", sans-serif', fontSize: '1.5rem', fontWeight: 600, lineHeight: 1.3 },
  h4: { fontFamily: '"Inter Tight", "Inter", sans-serif', fontSize: '1.125rem', fontWeight: 600, lineHeight: 1.3 },
  h5: { fontFamily: '"Inter Tight", "Inter", sans-serif', fontSize: '1rem', fontWeight: 600, lineHeight: 1.5 },
  h6: { fontFamily: '"Inter Tight", "Inter", sans-serif', fontSize: '0.875rem', fontWeight: 600, lineHeight: 1.5 },
  body1: { fontSize: '1rem', lineHeight: 1.6 },
  body2: { fontSize: '0.875rem', lineHeight: 1.5 },
  caption: { fontSize: '0.75rem', lineHeight: 1.4 },
  code: {
    fontFamily: '"JetBrains Mono", "Fira Code", "Consolas", monospace',
    fontSize: '0.875rem',
    lineHeight: 1.5,
  },
};
